/* global jQuery */

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import Emojify from 'app/components/shared/Emojify';
import classNames from 'classnames';

/* eslint-disable react/prefer-es6-class */
// TODO: Replace BootstrapModalMixin and BootstrapTooltipMixin and move to a class

import BootstrapModalMixin from 'app/lib/BootstrapModalMixin';
import BootstrapTooltipMixin from 'app/lib/BootstrapTooltipMixin';

export default createReactClass({
  displayName: 'BlockFieldsModal',

  mixins: [BootstrapModalMixin, BootstrapTooltipMixin],

  propTypes: {
    job: PropTypes.shape({
      id: PropTypes.string.isRequired,
      activatePath: PropTypes.string.isRequired,
      fields: PropTypes.array.isRequired,
      name: PropTypes.string,
      prompt: PropTypes.string,
      submit: PropTypes.string
    }).isRequired
  },

  getInitialState() {
    return { submitting: false, errors: {} };
  },

  componentDidMount() {
    jQuery(this.form).on("ajax:before", this.handleAjaxBefore);
    jQuery(this.form).on("ajax:success", this.handleAjaxSuccess);
    jQuery(this.form).on("ajax:error", this.handleAjaxError);
  },

  componentWillUnmount() {
    jQuery(this.form).off("ajax:before", this.handleAjaxBefore);
    jQuery(this.form).off("ajax:success", this.handleAjaxSuccess);
    jQuery(this.form).off("ajax:error", this.handleAjaxError);
  },

  render() {
    const promptText = this.props.job.prompt && (
      <p>
        <Emojify text={this.props.job.prompt} />
      </p>
    );

    const label = <Emojify text={this.props.job.name || "Continue"} />;
    const submitLabel = <Emojify text={this.props.job.submit || "Continue"} />;

    const continueButton = (
      this.state.submitting
        ? (
          <button
            type="submit"
            className="twbs-btn twbs-btn-primary"
            disabled={true}
          >
            {submitLabel}
          </button>
        )
        : (
          <button
            type="submit"
            className="twbs-btn twbs-btn-primary"
          >
            {submitLabel}
          </button>
        )
    );

    return (
      <div className="BlockFieldsModal modal fade zoom">
        <div className="modal-dialog">
          <form
            action={this.props.job.activatePath}
            acceptCharset="UTF-8"
            method="post"
            data-remote={true}
            ref={(form) => this.form = form}
          >
            <input name="utf8" type="hidden" value="✓" />
            <input type="hidden" name="authenticity_token" value={window._csrf['token']} />
            <div
              className="modal-content"
              style={{ "maxHeight": "80vh", "overflowY": "scroll" }}
            >
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={this.handleCloseClick}
                >
                  ×
                </button>
                <h4 className="modal-title">
                  {label}
                </h4>
                {promptText}
              </div>
              <div className="modal-body">
                {this.renderFields()}
              </div>
              <div className="modal-footer">
                {continueButton}
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  },

  handleCloseClick() {
    this.hide();
  },

  renderFields() {
    const nodes = [];

    for (let index = 0; index < this.props.job.fields.length; index++) {
      const field = this.props.job.fields[index];
      let el = null;
      let label = null;
      let error = null;

      const id = `field-${this.props.job.id}-${index}`;
      const name = `job[fields][${field.key}]`;

      const hint = field.hint && (
        <div className="dark-gray mb1">
          <Emojify text={field.hint} />
        </div>
      );

      error = this.state.errors[field.key] && (
        <div className="red mt1">
          {this.state.errors[field.key]}
        </div>
      );

      if (field.text) {
        label = field.text;
        el = (
          <div>
            {hint}
            <textarea
              className="form-control mt1"
              data-autofocus={(
                index === 0
                  ? "autofocus"
                  : undefined
              )}
              name={name}
              id={id}
              defaultValue={field.default}
              required={field.required}
            />
          </div>
        );
      } else if (field.select) {
        let opt, option, optionIndex;
        label = field.select;
        const options = [];

        if ((field.options.length <= 6) && field.required) {
          for (optionIndex = 0; optionIndex < field.options.length; optionIndex++) {
            option = field.options[optionIndex];
            opt = this.parseOption(option);
            options.push(
              <div key={optionIndex} className="radio">
                <label>
                  <input
                    type="radio"
                    name={name}
                    value={opt.value}
                    defaultChecked={opt.value === field.default ? true : undefined}
                    required={field.required}
                  />
                  <Emojify text={opt.label} />
                </label>
              </div>
            );
          }

          el = (
            <div className="mt1">
              {hint}
              {options}
            </div>
          );
        } else {
          // Make sure there's an empty option since it's not required
          if (!field.required) {
            options.push(
              <option key={-1} />
            );
          }

          for (optionIndex = 0; optionIndex < field.options.length; optionIndex++) {
            option = field.options[optionIndex];
            opt = this.parseOption(option);

            options.push(
              <option key={optionIndex} value={opt.value}>
                {opt.label}
              </option>
            );
          }
          el = (
            <div className="mt1">
              {hint}
              <select
                name={name}
                className="form-control"
                defaultValue={field.default}
                required={field.required}
              >
                {options}
              </select>
            </div>
          );
        }
      }

      if (el) {
        const optionalLabel = !field.required && (
          <small className="dark-gray ml1">
            (Optional)
          </small>
        );

        const labelClasses = classNames("bold", { "red": !!error });

        nodes.push(
          <div key={id} className="form-group">
            <label className={labelClasses} htmlFor={id}>
              <Emojify text={label} />
              {optionalLabel}
            </label>
            {el}
            {error}
          </div>
        );
      }
    }

    return nodes;
  },

  parseOption(option) {
    if (option === null) {
      return { value: "", label: "" };
    } else if (typeof (option) === 'object') {
      return option;
    }

    return { value: option, label: option };
  },

  handleAjaxBefore() {
    const errors = {};
    const broken = [];

    // Make sure all the fields that are required have values
    for (let index = 0; index < this.props.job.fields.length; index++) {
      const field = this.props.job.fields[index];
      if (field.required) {
        const el = jQuery(`[name='job[fields][${field.key}]']`);
        // Get the value from the DOM
        let val = el.val();

        // Get rid of whitespace for the before we validate
        val = jQuery.trim(val);

        // Add our error if the value is empty
        if (val === "") {
          errors[field.key] = "This field is required";
          broken.push(el);
        }
      }
    }

    if (jQuery.isEmptyObject(errors)) {
      return this.setState({ errors: {}, submitting: true });
    }

    // Show the errors
    this.setState({ errors });

    // Focus on the first broken fields
    broken[0].focus();

    // Stop the form from submitting
    return false;
  },

  handleAjaxSuccess() {
    this.hide();
    this.setState({ submitting: false });
  },

  handleAjaxError() {
    this.setState({ submitting: false });
  }
});
